<template>
    <div>
        <div class="headerBanner" v-if="!isMobile">
            <div class="headerBannerBg" :style="`background-image: url(${bannerBg});`">
                <img class="title" :src="title" alt="">
                <img class="desc" :src="desc" alt="">
            </div>
            <div class="daohang">
                <div class="daohBox">
                    <div v-for="(item,index) in list" :key="index" :class="tabIndex==index+1?'active':''" @click="turnClick(item.url)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="bannerShow" v-if="isMobile">
            <img class="bannerImg" :src="bannerBg" alt="">
            <img class="titleShow" :src="title" alt="">
            <img class="descShow" :src="desc" alt="">
        </div>
    </div>
</template>

<script>
import banner from '@/assets/mediaCenter/banner.png'
import title from '@/assets/mediaCenter/title.png'
import desc from '@/assets/mediaCenter/desc.png'
export default {
    name: 'aboutBanner',
    props:['tabIndex'],
    data() {
        return {
            bannerBg:banner,
            title:title,
            desc:desc,
            list:[
                {
                    name:'行业资讯',
                    url:'/mediaCenter/IndustryNews'
                },
                {
                    name:'企业动态',
                    url:'/mediaCenter/CompanyNews'
                },
                {
                    name:'公告',
                    url:'/mediaCenter/Notice'
                },
                {
                    name:'公示',
                    url:'/mediaCenter/Public'
                },
                {
                    name:'澄清与修改',
                    url:'/mediaCenter/Clarify'
                },
                {
                    name:'公众参与公示',
                    url:'/mediaCenter/NoticePub'
                }
            ]
        };
    },
    watch: {
        },
    mounted(){
        
    },
    methods: {
        //二级导航跳转
        turnClick(url){
            this.$router.push({
                path:url
            })
        }
    }
}
</script>
<style scoped>
     .headerBannerBg {
        height: 260px;
        background-size: cover;
        background-position: center;
    }
    .title{
        display: block;
        width:431px;
        margin: 0 auto;
        padding-top: 76px;
    }
    .desc{
        display: block;
        width: 314px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .daohang{
        width: 100%;
        height: 50px;
        background-color: #fff;
        box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.04);
    }
    .daohBox{
        width: 620px;
        margin: 0 auto;
        line-height: 48px;
        display: flex;
        justify-content: space-around;
        color: #333;
        font-size: 16px;
        font-weight: 400;
    }
    .daohBox div{
        cursor: pointer;
        padding: 0 5px;
    }
    .active{
        color: #247CD6;
        border-bottom: 2px solid #247CD6;
        padding: 0 5px;
        font-weight: bold;
    }
    /* 手机端banner图 */
    .bannerShow{
        position: relative;
        height: 150px;
    }
    .bannerImg{
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 150px;
    }
    .titleShow{
        display: block;
        width: calc(100% - 50px);
        margin: 0 auto;
        padding-top: 40px;
    }
    .descShow{
        display: block;
        width: 70%;
        margin: 0 auto;
        margin-top: 20px;
    }
</style>